/**
 * Aliquote INPS per anno
 * Fonte: Circolari INPS annuali
 *
 * Nota: Le aliquote possono variare. Verificare sempre con le circolari ufficiali.
 */

// Aliquote INPS Gestione Separata (professionisti senza altra cassa)
export const ALIQUOTE_INPS_GESTIONE_SEPARATA = {
  2023: 26.07,
  2024: 26.07,
  2025: 26.07,
  2026: 26.07,
};

// Aliquote INPS Artigiani (valori indicativi base, senza riduzioni)
export const ALIQUOTE_INPS_ARTIGIANI = {
  2023: 24.00,
  2024: 24.00,
  2025: 24.00,
  2026: 24.00,
};

// Aliquote INPS Commercianti (valori indicativi base, senza riduzioni)
export const ALIQUOTE_INPS_COMMERCIANTI = {
  2023: 24.48,
  2024: 24.48,
  2025: 24.48,
  2026: 24.48,
};

/**
 * Ottiene l'aliquota INPS corretta per tipo gestione e anno
 *
 * @param {string} tipoGestione - 'gestione-separata' | 'artigiani' | 'commercianti'
 * @param {number} anno - Anno di riferimento (es. 2026)
 * @returns {number} Aliquota in percentuale (es. 26.07)
 */
export function getAliquotaINPS(tipoGestione, anno) {
  let tabella;

  switch (tipoGestione) {
    case 'gestione-separata':
      tabella = ALIQUOTE_INPS_GESTIONE_SEPARATA;
      break;
    case 'artigiani':
      tabella = ALIQUOTE_INPS_ARTIGIANI;
      break;
    case 'commercianti':
      tabella = ALIQUOTE_INPS_COMMERCIANTI;
      break;
    default:
      tabella = ALIQUOTE_INPS_GESTIONE_SEPARATA;
  }

  // Se l'anno esiste nella tabella, usa quella aliquota
  if (tabella[anno] !== undefined) {
    return tabella[anno];
  }

  // Altrimenti usa l'ultimo anno disponibile (fallback)
  const anniDisponibili = Object.keys(tabella).map(Number).sort((a, b) => b - a);
  return tabella[anniDisponibili[0]];
}

/**
 * Ottiene tutte le aliquote disponibili per un tipo di gestione
 * Utile per debug o per mostrare storico
 *
 * @param {string} tipoGestione
 * @returns {Object} Oggetto con anni come chiavi e aliquote come valori
 */
export function getAllAliquote(tipoGestione) {
  switch (tipoGestione) {
    case 'gestione-separata':
      return { ...ALIQUOTE_INPS_GESTIONE_SEPARATA };
    case 'artigiani':
      return { ...ALIQUOTE_INPS_ARTIGIANI };
    case 'commercianti':
      return { ...ALIQUOTE_INPS_COMMERCIANTI };
    default:
      return { ...ALIQUOTE_INPS_GESTIONE_SEPARATA };
  }
}
